export class Apellido {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public apellido: string | undefined;
}